import { useSetAtom } from "jotai"
import { RefObject, useCallback } from "react"
import { currentTimeAtom } from "../state"

export default function useProgressValueChange(
  elementRef: RefObject<HTMLVideoElement | HTMLAudioElement | null>
) {
  const setCurrentTime = useSetAtom(currentTimeAtom)

  return useCallback(
    (value: number[]) => {
      if (!elementRef?.current) return
      const nextTime = value[0]
      if (nextTime === undefined) return

      // Update UI immediately. On mobile, timeupdate often only fires after
      // the seek settles (finger release), so the controlled scrubber would
      // otherwise freeze until then.
      setCurrentTime(nextTime)
      elementRef.current.currentTime = nextTime
    },
    [elementRef, setCurrentTime]
  )
}
